<template>
  <div class="stars_evalua-root">
      <ul class="stars">
        <li :class="['star', isEdit?'':'not_edit']" v-for="(item,index) in starsList" :key="index" @click="checkStar(index)">
          <v-icon class="icon" v-if="item.checked" name="star" scale="2.8"></v-icon>
          <v-icon class="icon" v-else name="regular/star" scale="2.8"></v-icon>
        </li>
      </ul>
      <p class="rating-desc">{{evaluaTexts[starNum-1]}}</p>
    </div>
</template>

<script>
import "vue-awesome/icons/star" 
import "vue-awesome/icons/regular/star"
import Icon from "vue-awesome/components/Icon";

export default {
  name: "Rating",
  props: {
    starNum: {
      type: Number,
      required: true
    },
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const evaluaTexts = [
      "非常不满意，各方面都很差",
      "不满意，各方面比较差",
      "一般，需要改善",
      "比较满意，但仍可改善",
      "非常完美，无可挑剔"
    ];
    // const starsList = Array(5)
    //   .fill(null)
    //   .map((item,i) => ({ checked: this.isEdit ? false:(i + 1 <= this.starNum) }));

    return {
      // starsList,
      evaluaTexts,
    };
  },
  computed: {
    starsList() {
      return Array(5)
        .fill(null)
        .map((item,i) => ({ checked: this.isEdit ? false:(i + 1 <= this.starNum) }));
    }
  },
  methods: {
    checkStar(index) {
      if (!this.isEdit) return;
      this.$emit("update:starNum", index + 1);
      for (const [i, item] of this.starsList.entries()) {
        if (i <= index) item.checked = true;
        else item.checked = false;
      }
    },
    
  },
  components: {
    "v-icon": Icon
  }
};
</script>

<style lang="stylus">
@import '~@/assets/css/variable'
.stars_evalua-root
    color $rating_primary_color  
    // display inline-block
  .stars
    display flex
    justify-content center 
    margin-bottom 13px 
    .star 
      cursor pointer
      &.not_edit 
        cursor auto 
      .icon 
        display block 
  .rating-desc 
    display block 
    font-size 20px 
    text-align center
  
</style>
